<div [formGroup]="licenseForm">
  <p-fieldset>
   <p-header class="article-title">
     <div class="article-title">Foto da licença</div>
   </p-header>
   <div class="form-group" style="align-items: flex-start; margin-top: 0">
     <app-sailor-upload
     [path]="imgPreview"
     title="Imagem da licença"
     (finishEvent)="receiveUploadUrl($event)"
     >
     </app-sailor-upload>
   </div>
 </p-fieldset>
 <br />
 <p-fieldset>
   <p-header class="article-title">
     <div class="article-title">Dados da licença</div>
   </p-header>
   <div class="form-group">
     <div class="form-control field">
       <label>{{ "Tipo de habilitação" | translate }}</label>
       <p-dropdown
         placeholder="Selecione..."
         [disabled]="false"
         required
         [filter]="true"
         [options]="typesLicense"
         formControlName="typeLicense"
         appendTo="body"
         name="selectedBoatId"
       >
       </p-dropdown>
     </div>
     <div class="form-control field">
       <label for="register">{{ "REGISTER" | translate }}</label>
       <input
         pInputText
         name="register"
         formControlName="register"
         maxlength="50"
       />
     </div>
     <div class="form-control field">
       <label for="expiration">{{ "Validade" | translate }}</label>
       <p-calendar
         dateFormat="dd/mm/yy"
         name="expiration"
         formControlName="expiration"
         appendTo="body"
         [showIcon]="true"
         i18n
         [monthNavigator]="true"
         [yearNavigator]="true"
         [yearRange]="'2000:2055'"
         rPCalendarMask
       >
       </p-calendar>
     </div>
   </div>
   <div class="form-group">
     <div class="form-control field">
       <label for="licenceCountry">{{ "COUNTRY" | translate }}</label>
       <p-dropdown
         [options]="countries"
         name="licenceCountry"
         appendTo="body"
         (onChange)="loadStates($event.value.label)"
         formControlName="country"
         placeholder="Selecione..."
         [filter]="true"
       >
       </p-dropdown>
     </div>
     <div class="form-control field">
       <label for="licenceState">{{ "FS" | translate }}</label>
       <p-dropdown
         [options]="states"
         name="licenceState"
         appendTo="body"
         (onChange)="loadCities(undefined, $event.value)"
         formControlName="state"
         placeholder="Selecione..."
         [filter]="true"
       >
       </p-dropdown>
     </div>
     <div class="form-control field">
       <label for="licenceCity">{{ "CITY" | translate }}</label>
       <p-dropdown
         [options]="cities"
         name="licenceCity"
         appendTo="body"
         formControlName="city"
         placeholder="Selecione..."
         [filter]="true"
       >
       </p-dropdown>
     </div>
   </div>
 </p-fieldset>
</div>